module.exports = __webpack_public_path__ + "static/media/logo-red@200x.6ec2ef34.png";